import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import InputField from '../../Reusable/InputField';

const FourthSection = (props) => {
  const { onChange, state, errors, errorsHandler } = props || {};

  return (
    <Card>
      <Card.Header className="primary-header-card">
        <Card.Title className="d-flex gap-3 align-items-center">
          Napomena
        </Card.Title>
      </Card.Header>
      <Card.Body>
        <Row>
          <Col>
            <InputField
              id="note"
              name="note"
              placeholder={'Napomena'}
              onChange={onChange}
              value={state.note}
              multiline={true}
              rows={2}
              required
              error={errors}
              errorsHandler={errorsHandler}
            />
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default FourthSection;
